import type { NormalizedOrderData, ParameterDefaultsByPath } from './getNormalizedOrderDataDiff';
import { ALGO_PARAMETER_PATH_PREFIX, getNormalizedOrderDataDiff } from './getNormalizedOrderDataDiff';
import { normalizeComparablePayload } from './normalizeComparablePayload';

export type StrategyParameterDefault = { Name: string; DefaultValue?: string };

/**
 * Returns true if there are pre-trade-relevant differences between a form
 * request payload and a scenario NewOrderSingle.
 */
export function hasPreTradeRelevantChanges(
  formPayload: unknown,
  scenarioNOS: unknown,
  strategyParameters?: ReadonlyArray<StrategyParameterDefault>
): boolean {
  const formData = normalizeComparablePayload(formPayload) as NormalizedOrderData;
  const nosData = normalizeComparablePayload(scenarioNOS) as NormalizedOrderData;
  const parameterDefaults = buildParameterDefaults(strategyParameters);
  return getNormalizedOrderDataDiff(formData, nosData, parameterDefaults).length > 0;
}

function buildParameterDefaults(
  strategyParameters: ReadonlyArray<StrategyParameterDefault> | undefined
): ParameterDefaultsByPath {
  const out = new Map<string, string>();
  if (!strategyParameters?.length) {
    return out;
  }
  for (const parameter of strategyParameters) {
    if (typeof parameter.DefaultValue === 'string') {
      out.set(`${ALGO_PARAMETER_PATH_PREFIX}${parameter.Name}`, parameter.DefaultValue);
    }
  }
  return out;
}
